import {
  dimensiondata_1_tetelek_group_w200_row,
  year_column,
  szazalek_value_1_data_precision_year_summary,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const megujuloReszaranyConfig: PivotGridConfig = {
  showChart: false,
  filterYear: { numberOfYears: 5 },
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/MegujuloReszarany',
      select: ['date', 'dimension_1', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      ...dimensiondata_1_tetelek_group_w200_row,
      year_column,
      szazalek_value_1_data_precision_year_summary,
      order_1,
      order_2
    ],
  },
};
